module.exports = __webpack_public_path__ + "static/media/moonlight.33adbb1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/moonlight.mp3
// module id = Ys6T
// module chunks = 3